import { ScreenQuestionProps } from './types';

const BASE_WORK_EXPERIENCE_QUESTION: ScreenQuestionProps = {
  title: 'Work Experience',
  question: 'How many years of relevant experience do you have?',
  type: 'WorkExperience',
  category: 'PreDefined',
  answerType: 'numeric',
};

export const WORK_EXPERIENCE_PREDEFINED_QUESTION: ScreenQuestionProps = {
  ...BASE_WORK_EXPERIENCE_QUESTION,
  required: true,
};

export const createWorkExperienceQuestion = (
  overrides: Partial<ScreenQuestionProps> = {},
): ScreenQuestionProps => ({
  ...BASE_WORK_EXPERIENCE_QUESTION,
  required: false,
  jobFunction: '',
  expectedAnswer: undefined,
  ...overrides,
});
